import { useQuery } from "@tanstack/react-query";
import { getAppConfig, type AppConfig } from "@app/services/appConfigApi";

export function useAppConfig() {
  return useQuery<AppConfig>({
    queryKey: ["appConfig"],
    queryFn: getAppConfig,
    staleTime: 60000, // 1 minute
    gcTime: 300000, // 5 minutes
  });
}

